export const UPDATE_FORM = "UPDATE_HQ_FORM";
export const RESET_FORM = "RESET_HQ_FORM";

export const updateHQForm = (formData) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_FORM,
      payload: formData,
    });
  };
};

export const resetHQForm = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_FORM,
    });
  };
};
